module.exports = __webpack_public_path__ + "img/edit.40e48d2f.svg";